
export default function Gallery() {
  const images = [
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/af91a867d747f01b6380a9247ff23ec3.png',
      title: 'Máquina perforadora moderna'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/46334f40d79a70db00be1a338001842c.jpeg',
      title: 'Equipo de perforación en operación'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/b77e6be7ebe8a12109bfccb14f14367f.jpeg',
      title: 'Estudio geofísico del terreno'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/1a58dc41f287299374a94aaf19513c7a.png',
      title: 'Pozo terminado con bomba instalada'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/039c4adbd65d47523007dc67e11b9fcf.png',
      title: 'Perforación profunda completada'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/26437dd115ba315d73c5caabe4420206.jpeg',
      title: 'Sistema de riego agrícola instalado'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/f0f93f6759ae4b0e4e273855792618a5.jpeg',
      title: 'Pozo residencial en funcionamiento'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/4a7dd6468ccfa3b8ca53ba37eb5bdca4.png',
      title: 'Proyecto industrial completado'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/7094e10c367591d55fc615292e91ebcc.png',
      title: 'Sistema de almacenamiento instalado'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/6fa19e4ac305300cd3298238152e47e5.jpeg',
      title: 'Instalación de bomba sumergible'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/3b3c2e722edaf2bba17ac52e628d3beb.jpeg',
      title: 'Proyecto comunitario finalizado'
    },
    {
      url: 'https://static.readdy.ai/image/8918f5c471cb3cf0b126a471ea443ce2/ddbd446a3758ab4c91d3017b1eba31ef.jpeg',
      title: 'Mantenimiento y limpieza realizado'
    }
  ];

  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-2 sm:mb-4">
            Galería de Trabajos
          </h2>
          <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Conoce algunos de nuestros proyectos exitosos
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4 lg:gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-lg sm:rounded-xl shadow-md hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-32 sm:h-48 lg:h-64 w-full overflow-hidden">
                <img 
                  src={image.url}
                  alt={image.title}
                  className={`w-full h-full ${index === 3 ? 'object-cover object-center scale-125' : 'object-cover object-top'} group-hover:scale-110 transition-transform duration-500`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
